import {
  primaryColors,
  whiteShades,
  transparentColors,
} from "../../assets/styles/helpers/colors.styles";

export const sliderStyles = {
  "&.MuiSlider-root": {
    padding: "1rem 0",
  },
  ".MuiSlider-mark": {
    width: "0.5rem",
    height: "0.5rem",
    borderRadius: "0.5rem",
    backgroundColor: primaryColors.white,
    opacity: 1,
    "&:first-of-type": {
      display: "none",
    },
  },
  ".MuiSlider-markActive": {
    width: "0.5rem",
    height: "0.5rem",
    borderRadius: "0.5rem",
    backgroundColor: primaryColors.orange,
    opacity: 1,
  },
  ".MuiSlider-track": {
    backgroundColor: primaryColors.orange,
    border: "none",
    borderRadius: 0,
  },
  ".MuiSlider-rail": {
    backgroundColor: whiteShades.shade1,
    borderRadius: 0,
  },
  ".MuiSlider-thumb": {
    backgroundColor: primaryColors.orange,
    boxShadow: "none",
    width: "1rem",
    height: "1rem",
    "&.Mui-focusVisible": {
      boxShadow: `0px 0px 0px 8px ${transparentColors.orangeShade2}`,
    },

    "&:hover": {
      boxShadow: `0px 0px 0px 8px ${transparentColors.orangeShade2}`,
    },
    "&.Mui-active": {
      boxShadow: `0px 0px 0px 8px ${transparentColors.orangeShade3}`,
    },
    "&::before": {
      boxShadow: "none",
    },
    "&::after": {
      width: "2rem",
      height: "2rem",
    },
    ".MuiSlider-valueLabel": {
      transform: "translateY(calc(-100% + 0.25rem)) scale(1)",
      "&:before": {
        content: "none",
      },
    },
  },
  ".MuiSlider-valueLabel": {
    backgroundColor: transparentColors.transparent,
    // MUI defaults the value-label text to white; theme it to match the
    // slider's other text (primary).
    color: primaryColors.white,
    fontWeight: 900,
    fontFamily: "Helvetica Neue",
    fontStretch: "condensed",
    fontSize: "1rem",
  },
};
